export const logoCompaniesFixture = new Map<string, string>();

logoCompaniesFixture.set('TELCEL-PREPAGO', 'assets/images/logo-telcel.svg');
logoCompaniesFixture.set('AT&T-PREPAGO', 'assets/images/logo-at&t.svg');
logoCompaniesFixture.set('MOVISTAR-PREPAGO', 'assets/images/logo-movistar.svg');